<template>
    <div>
        <div :class="'alert alert-dismissible fade show alert-' + type">
            <strong v-if="title">
                {{title}}
            </strong>
            {{message}}
            <button type="button" class="close" @click="dismiss">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
    </div>
</template>

<script>
  export default {
    props: {
      type: {
        type: String,
        default: "info",
        required: true,
      },
      title: {
        type: String,
        required: false,
      },
      message: {
        type: String,
        required: true,
      }
    },
    methods: {
      dismiss() {
        this.$emit('dismiss-alert');
      }
    }
  }
</script>
